import React from 'react';
import {data} from "../../store/data";
import Intro from "./sections/Intro";
import Header from "../Header";
import Footer from "../Footer";
import {
	ABOUT_ME,
	ABOUT_ME_PATH,
	CONTACT_FORM,
	CONTACT_FORM_PATH,
	HOME,
	HOME_COMPONENT_NAV_ITEMS,
	INTERNSHIPS,
	INTERNSHIPS_PATH,
	INTRO,
	INTRO_PATH,
	MD_BREAKPOINT,
	PROJECTS,
	PROJECTS_PATH,
	SKILLS,
	SKILLS_PATH
} from "../../Constants/Constants";
import About from "./sections/About";
import {BG_COLORS, PURPLE_GRADIENT_TO_RIGHT, WHITE, GREEN_100, RED_A100, BLUE_100} from "../../Constants/Colors";
import Projects from "./sections/Projects";
import Internships from "./sections/Internships";
import Skills from "./sections/Skills";
import ContactForm from './sections/ContactForm';

export const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));
export const shuffle = (arr) => {
	for (let i = arr.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[arr[i], arr[j]] = [arr[j], arr[i]];
	}
	return arr;
};

class Home extends React.Component {


	constructor(props) {
		super(props);
		let bgColors = BG_COLORS;
		//console.log("Before shuffle", bgColors);
		//bgColors = shuffle(bgColors);
		//console.log("After shuffle", bgColors);

		this.state = {
			data: data,
			navbarHeight: 0,
			navbarWidth: 0,
			references: {},
			bgColors: bgColors
		};
		this.componentRef = React.createRef();
		this.updateRef = this.updateRef.bind(this);
	}


	componentDidMount() {
		// window.scrollTo(0, 0);
		this.updateRef(HOME, this.componentRef);
		this.updateRef("main", this.componentRef);
		// .then((res)=>//console.log("state Updated", res))
		// .catch(err=>//console.log(err));
	}

	updateRef(title, value) {
		// console.log("UpdateRef, Called for ", title, value);
		this.setState((state) => ({...state, references: {...state.references, [title]: value}}));
		// {
		// 	let newState = {...state}; //deepCopy(state);
		// 	newState.references[title] = value;
		// 	//Object.assign({[title]: value}, this.state.references);
		// 	//console.log("Before Update Ref", state);
		// 	return newState;
		// }
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		//console.log("State of Refs in Home:", this.state);
	}

	styles = {
		page: {
			minHeight: "100vh"
		},
		navbar: {
			small: {
				position: 'fixed',
				top: 0,
				width: "100%",
				image: {
					height: "40px",
					alignSelf: "center",
					// margin: "auto"
				},
				navItemsContainer: {
					float: "right",
					maxWidth: "50vw",
					padding: "1rem",
					textAlign: "right",
					backgroundImage: PURPLE_GRADIENT_TO_RIGHT
				}
			},
			borderRight: "0.25em solid white",
			padding: 0,
			// backgroundColor: "#4527A0",
			backgroundImage: PURPLE_GRADIENT_TO_RIGHT,
			// color: '#eee',
			position: 'fixed',
			top: 0,
			// height: "100vh",
			width: "100vw",
			// minWidth: "20%",
			// maxWidth: "30%",
			zIndex: 100000,
			// flexDirection: "column",
			// alignItems: "center",
			// justifyContent: "space-around",
			transition: "0.5s",
			image: {
				// marginTop:"2rem",
				// paddingTop: "2rem",
				// height: "10em",
				height: "3rem",
				alignSelf: "center",
				// margin: "auto"
			},
			navItemsContainer: {
				// opacity: 1,
				zIndex: 10000000,
				// flexDirection: "column",
				navbarItem: {
					// fontSize: "2rem",
					// fontWeight: 600,
					textDecoration: "none"
				}
			}
		}
	};

	updateNavbarHeight(height) {
		this.setState({navbarHeight: height})
	}

	updateNavbarWidth(width) {
		this.setState({navbarWidth: width})
	}

	render() {
		let subtitles = [
			"A Web Developer",
			// "A Machine Learning Enthusiast",
			"Computer Science Engineer"
		];

		let {bgColors} = this.state;
		return (
			<div ref={this.componentRef}>
				<Header
					parentName={"home"}
					key={"home-header"}
					window_width={this.props.window_width}
					window_height={this.props.window_height}
					styles={this.styles.navbar}
					navItems={HOME_COMPONENT_NAV_ITEMS}
					updateNavbarWidth={(width) => this.updateNavbarWidth(width)}
					references={this.state.references}
				/>
				<div style={{
						// paddingLeft: this.props.window_width >= MD_BREAKPOINT ? this.state.navbarWidth : 0
					}} 
					id="main"
				>
					<Intro
						window_width={this.props.window_width}
						window_height={this.props.window_height}
						backgroundColor={bgColors[0]}
						title={INTRO}
						path={INTRO_PATH}
						subtitles={subtitles}
						updateRef={(title, value) => this.updateRef(title, value)}
					/>
					<About
						window_width={this.props.window_width}
						window_height={this.props.window_height}
						backgroundColor={GREEN_100}
						title={ABOUT_ME}
						path={ABOUT_ME_PATH}
						updateRef={(title, value) => this.updateRef(title, value)}
					/>
					<Skills
						window_width={this.props.window_width}
						window_height={this.props.window_height}
						backgroundColor={WHITE}
						title={SKILLS}
						data={this.state.data.skills}
						path={SKILLS_PATH}
						updateRef={(title, value) => this.updateRef(title, value)}
					/>
					<Projects
						window_width={this.props.window_width}
						window_height={this.props.window_height}
						backgroundColor={GREEN_100}
						title={PROJECTS}
						data={this.state.data.projects}
						path={PROJECTS_PATH}
						updateRef={(title, value) => this.updateRef(title, value)}
					/>
					<Internships
						window_width={this.props.window_width}
						window_height={this.props.window_height}
						backgroundColor={BLUE_100}
						data={this.state.data.internships}
						title={INTERNSHIPS}
						path={INTERNSHIPS_PATH}
						updateRef={(title, value) => this.updateRef(title, value)}
					/>
					<ContactForm 
						window_width={this.props.window_width}
						window_height={this.props.window_height}
						backgroundColor={WHITE}
						title={CONTACT_FORM}
						path={CONTACT_FORM_PATH}
						updateRef={(title, value) => this.updateRef(title, value)}
					/>
					<Footer/>
				</div>
			</div>
		);
	}
}

export default Home;